<template>
  <span class="svg-ico-ellipsis-circle">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.34766 13.078C9.34766 13.7684 8.78801 14.328 8.09766 14.328C7.4073 14.328 6.84766 13.7684 6.84766 13.078C6.84766 12.3876 7.4073 11.828 8.09766 11.828C8.78801 11.828 9.34766 12.3876 9.34766 13.078Z" :fill="color"/>
      <path d="M18.3477 13.078C18.3477 13.7684 17.788 14.328 17.0977 14.328C16.4073 14.328 15.8477 13.7684 15.8477 13.078C15.8477 12.3876 16.4073 11.828 17.0977 11.828C17.788 11.828 18.3477 12.3876 18.3477 13.078Z" :fill="color"/>
      <path d="M12.5977 14.328C13.288 14.328 13.8477 13.7684 13.8477 13.078C13.8477 12.3876 13.288 11.828 12.5977 11.828C11.9073 11.828 11.3477 12.3876 11.3477 13.078C11.3477 13.7684 11.9073 14.328 12.5977 14.328Z" :fill="color"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2.59766 12.8281C2.59766 18.3727 7.0531 22.8281 12.5977 22.8281C18.1422 22.8281 22.5977 18.3727 22.5977 12.8281C22.5977 7.28358 18.1422 2.82812 12.5977 2.82812C7.0531 2.82812 2.59766 7.28358 2.59766 12.8281ZM3.99766 12.8281C3.99766 17.5995 7.8263 21.4281 12.5977 21.4281C17.369 21.4281 21.1977 17.5995 21.1977 12.8281C21.1977 8.05677 17.369 4.22812 12.5977 4.22812C7.8263 4.22812 3.99766 8.05677 3.99766 12.8281Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this && this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default () { return this && this.$store.state.color['coolGrey-50'] } },
    isFixedColor: { type: Boolean },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
